var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import CheckIcon from '@mui/icons-material/Check';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Box, Paper, Tooltip, Typography } from '@mui/material';
import React, { useRef, useState } from 'react';
import { ix } from '../../../utils/ix';
import { useStyles } from './CopyContainer.styles';
export function CopyContainer({ id, className, content }) {
    const [isCopied, setCopied] = useState(false);
    const copyAreaRef = useRef(null);
    const classes = useStyles();
    const onClick = () => __awaiter(this, void 0, void 0, function* () {
        var _a;
        if ((_a = copyAreaRef.current) === null || _a === void 0 ? void 0 : _a.textContent) {
            yield navigator.clipboard.writeText(copyAreaRef.current.textContent);
            setCopied(true);
        }
    });
    const onMouseEnter = () => setCopied(false);
    const copiedMessage = (React.createElement("div", { className: classes.message },
        React.createElement(CheckIcon, { classes: { root: classes.icon }, color: "success" }),
        React.createElement(Typography, null, "Copied to Clipboard")));
    const notCopiedMessage = (React.createElement("div", { className: classes.message },
        React.createElement(ContentCopyIcon, { classes: { root: classes.icon }, color: "primary" }),
        React.createElement(Typography, null, "Click to copy")));
    const tooltipContent = isCopied ? copiedMessage : notCopiedMessage;
    return (React.createElement(Paper, { id: id, className: className, classes: { root: classes.paper }, elevation: 2 },
        React.createElement(Tooltip, { id: ix(id, 'tooltip'), title: tooltipContent, classes: {
                tooltip: classes.tooltip,
                arrow: classes.arrow,
            }, placement: "top-end", arrow: true },
            React.createElement(Box, { id: ix(id, 'copy-area'), ref: copyAreaRef, className: classes.copyArea, onClick: onClick, onMouseEnter: onMouseEnter },
                React.createElement(Typography, { variant: "body2" }, content)))));
}
//# sourceMappingURL=CopyContainer.js.map